"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuidesStates = exports.GuidesEventType = void 0;
var GuidesEventType;
(function (GuidesEventType) {
    GuidesEventType["FETCH_GUIDE"] = "FETCH_GUIDE";
    GuidesEventType["DONE_INVOKE_FETCH_GUIDE"] = "done.invoke.fetchGuide";
    GuidesEventType["ERROR_FETCH_GUIDE"] = "error.platform.fetchGuide";
    GuidesEventType["HIDE_GUIDE"] = "HIDE_GUIDE";
})(GuidesEventType = exports.GuidesEventType || (exports.GuidesEventType = {}));
var GuidesStates;
(function (GuidesStates) {
    GuidesStates["INIT"] = "init";
    GuidesStates["IDLE"] = "idle";
    GuidesStates["NO_PRACTICE_GROUPS"] = "noPracticeGroups";
    GuidesStates["NO_GUIDES"] = "noGuides";
    GuidesStates["LOADING_GUIDE"] = "loadingGuide";
    GuidesStates["LOAD_GUIDE_SUCCESS"] = "loadGuideSuccess";
    GuidesStates["LOAD_GUIDE_FAILURE"] = "loadGuideFailure";
    GuidesStates["SHOW_GUIDE"] = "showGuide";
})(GuidesStates = exports.GuidesStates || (exports.GuidesStates = {}));
//# sourceMappingURL=typings.js.map